export const thankYouNoteConstants = {
    // Add and editing thank you note
    SAVING_THANK_YOU_NOTE_REQUEST: 'SAVING_THANK_YOU_NOTE_REQUEST',
    SAVING_THANK_YOU_NOTE_SUCCESS: 'SAVING_THANK_YOU_NOTE_SUCCESS',
    SAVING_THANK_YOU_NOTE_FAILURE: 'SAVING_THANK_YOU_NOTE_FAILURE',

    // Loading thank you notes
    LOAD_THANK_YOU_NOTES_REQUEST: 'LOAD_THANK_YOU_NOTES_REQUEST',
    LOAD_THANK_YOU_NOTES_SUCCESS: 'LOAD_THANK_YOU_NOTES_SUCCESS',
    LOAD_THANK_YOU_NOTES_FAILURE: 'LOAD_THANK_YOU_NOTES_FAILURE',

    // Delete thank you note
    DELETE_THANK_YOU_NOTE_REQUEST: 'DELETE_THANK_YOU_NOTE_REQUEST',
    DELETE_THANK_YOU_NOTE_SUCCESS: 'DELETE_THANK_YOU_NOTE_SUCCESS',
    DELETE_THANK_YOU_NOTE_FAILURE: 'DELETE_THANK_YOU_NOTE_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/thankYouNote.constants.js